<template>
    <div class="page-favorites">
        <b-container fluid>
            <div class="p-4">
                <p>
                    Welcome to your favorites page. Look like you have selected some amazing pianos. To help assist you
                    in your quest of finding that perfect piano, we recommend that you print your favorites page then
                    come into our store for a personal demonstration of each piano.
                </p>

                <p><a id="print-button" href @click.prevent="printPage()"><i class="fa fa-print"></i> Print Page</a></p>
            </div>

            <div v-if="pianos.length">
                <router-link :to="`/pianos/${piano.id}`" class="piano media" v-for="piano in pianos" :key="piano.id">
                    <img class="piano-thumbnail img-thumbnail" :src="piano.thumbnail || 'http://lorempixel.com/512/512/'" alt="">
                    <div class="media-body p-3">
                        <b-row>
                            <b-col>{{ piano.manufacturer }}</b-col>
                            <b-col>{{ piano.model || piano.name }}</b-col>
                            <b-col class="text-right"><router-link :to="`/pianos/${piano.id}`" class="info-button">i</router-link></b-col>
                        </b-row>
                        <p class="mb-2">Price: {{ piano.price || 'Contact us' }}</p>

                        <p>{{ piano.description }}</p>
                    </div>
                </router-link>
            </div>
            <div v-if="!pianos.length">
                <h1 class="text-center mt-5">
                    No favorites selected.
                    <router-link to="/">Find pianos now.</router-link>
                </h1>
            </div>
        </b-container>
    </div>
</template>

<script>
export default {
    data() {
        const favorites = (localStorage.favoritePianos || '').split(',');

        return {
            pianos: this.$store.state.pianos.filter((piano) => {
                return favorites.indexOf(piano.id + '') > -1
            })
        };
    },


    methods: {
        printPage() {
            window.print();
        }
    }
}
</script>

<style type="text/scss" lang="scss">
/*there is an issue with the style loader so we can't include the styles here, go to styes/_pages.scss instead*/
</style>


// WEBPACK FOOTER //
// src/pages/Favorites.vue